import React, { useEffect, useState, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import SwitchOnOff from "../AntSwitch";

const SCAN_PAUSE = 2000;
const BARCODE_MODE = "barCode";
const QR_CODE_MODE = "qrCode";

export const QrBarcodeScanner = ({
  onScanSuccess,
  onScanFailure,
  removeMode = false,
}) => {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem("scannerMode") || BARCODE_MODE;
  });
  const scannerRef = useRef(null);
  const isScanningPaused = useRef(false);

  useEffect(() => {
    const scanner = new Html5Qrcode("reader", {
      useBarCodeDetectorIfSupported: true,
    });
    scannerRef.current = scanner;
    init(scanner, mode);

    return () => cleanup(scanner);
  }, []);

  const cleanup = async (scanner) => {
    if (scanner) {
      await scanner.stop();
      scanner.clear();
    }
  };

  const init = async (scanner, mode) => {
    let cameras = [];
    try {
      cameras = await Html5Qrcode.getCameras();
    } catch (err) {
      if (onScanFailure) {
        onScanFailure(err);
      }
      return;
    }

    const qrboxFunction = (viewfinderWidth, viewfinderHeight) => {
      const minEdgePercentage = 0.7;
      if (mode === QR_CODE_MODE) {
        const minEdgeSize = Math.min(viewfinderWidth, viewfinderHeight);
        const qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
        return { width: qrboxSize, height: qrboxSize };
      }

      const width = viewfinderWidth * 0.8;
      const height = width * 0.35;
      return { width, height };
    };

    if (cameras?.length > 0) {
      scanner.start(
        { facingMode: "environment" },
        { fps: 20, qrbox: qrboxFunction },
        async (decodedText) => {
          if (!isScanningPaused.current) {
            isScanningPaused.current = true;

            if (onScanSuccess) {
              onScanSuccess(decodedText, scanner);
            }

            await scanner.pause();

            setTimeout(async () => {
              try {
                scanner.resume();
              } catch (err) {
                onScanFailure?.(err);
              } finally {
                isScanningPaused.current = false;
              }
            }, SCAN_PAUSE);
          }
        },
        (error) => onScanFailure && onScanFailure(error)
      );
    }
  };

  const handleChange = async () => {
    const newMode = mode === BARCODE_MODE ? QR_CODE_MODE : BARCODE_MODE;
    localStorage.setItem("scannerMode", newMode);
    setMode(newMode);
    await cleanup(scannerRef.current);
    init(scannerRef.current, newMode);
  };

  return (
    <>
      <SwitchOnOff
        leftLabel={"Barcode"}
        rightLabel={"QR Code"}
        checked={mode === QR_CODE_MODE}
        setChecked={handleChange}
      />
      <div
        id="reader"
        style={{
          border: "4px solid",
          borderColor: removeMode ? "#f44336" : "transparent",
          borderRadius: 8,
          transition: "border-color 0.3s ease",
        }}
      ></div>
    </>
  );
};
